enum EnumSentFaxItemType {
    Prescription = 1, // PIN
    ConsultationRequest = 2, // PIN
    Encounter = 3, // NO PIN
    LabRequest = 4, // PIN
    Summary = 5, // NO PIN
    RadpdfForm = 6,
    TemporaryFile = 7,
    ObstetricalFile = 8,
    WorkSafeBcForm = 9,
    InboundFax = 10,
    AttachmentFileType = 11,
    GrowthChart = 12,
    // File 13 correspond to OrphanFile see EnumSentFax.cs
    ReturnedWithComment = 14,
    Document = 15,
    PrivateBill = 16
}

export { EnumSentFaxItemType };
